export default __webpack_public_path__ + "static/media/placeholder_notification_icon.c3a05781.jpg";